import http from '../utils/http.js'
// import token from './token.js'
// console.log(token.gettoken(),'token');
export default {
	//获取私有key
	plains(param){
	    return http.get('/api/system/plains.jspx',param);
	},
	//登录
	login(param){
	    return http.post('/api/logonact/login.jspx',param);
	},
	//系统验证信息
	sys_loads(){
	    return http.get('/api/system/loads.jspx');
	},
	//修改密码
	chpwd(param){
	    return http.post('/api/logonact/chpwd.jspx',param);
	},
	//退出
	logout(param){
	    return http.post('/api/logonact/login.jspx',param);
	},
	//业务字典
	options(resid){
	    return http.post('/api/comboxact/options.jspx?enumops=' + resid);
	},
	//单表查询
	load(resid,param){
	    return http.post('/api/comxact/load.jspx?resid='+ resid,param);
	},
	//单表保存
	save(resid,param){
	    return http.post('/api/comxact/save.jspx?resid='+ resid,param);
	},
	//单表删除
	remove(resid,param){
	    return http.post('/api/comxact/remove.jspx?resid='+ resid,param);
	},
	//树形
	tree(param){
	    return http.get('/api/treeact/load.jspx',param);
	},
	//树形
	regionTree(resid,param){
		return http.post('/api/treeact/load.jspx?type='+ resid,param);
	},
	//文件上传
	upload(resid,param){
	    return http.post('/api/uploader/upload.jspx?resid='+ resid,param);
	},
	//类的接口统一调用
	portal(resid,param){
	    return http.post('/api/portal.php?resid='+ resid,param);
	},
	portalx(resid,param){
		return http.fetchPost('/api/portal.php?resid='+ resid,param);
	},
	// 获取底部备案号
	getbuttom(resid,param){
		return http.get('/api/selectact/query.jspx?resid='+ resid,param);
	},
	//列表
	query(resid,param){
				return http.post('/api/selectact/query.jspx?resid='+ resid,param);
	},
	getinages(id){
			return http.postImage('/api/appendix/image.jspx?id='+id)
	},
	//新增留言
	getmessage(resid,param){
		return http.get('/api/comxact/save.jspx?resid='+ resid,param);
	},
	//获取token接口 post
	gettoken(param){
		return http.posttoken('/api/comx/open/token.jspx',param);
	},
	//带有token的接口
	newquest(param,heads){
		return http.newpost('/api/comx/open/apis.jspx',param,heads);
	},
	
	
}